<template>
  <div class="bg-white rounded-md border border-gray-200 min-h-full drop-shadow-2xl">
    <div v-for="(menu, index) in menus" :key="index" class="">
      <router-link :to="{path:menu.url}" class="px-4 py-3 relative hover:bg-gray-100 hover:text-pink-600 text-gray-800 text-sm font-medium border-b border-gray-200 focus:z-10 focus:text-blue-700 w-full rounded-t-lg inline-flex items-center"
                   :class="{'text-pink-600':menu.active}"> {{ menu.title }}</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageSideBarMenu",
  props: {
    menus: Array
  }
}
</script>

<style scoped>

</style>
